// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CustomValidationDTO  {
    _originalTypeClassName = "Loom.BO.CustomValidationDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CustomValidationDTO.translate = translateService;
}
this.Summary = [];
this.CustomValidationDTOKey = null;
this._key = this.CustomValidationDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Summary:any;
private _CustomValidationDTOKey:any;
get CustomValidationDTOKey(): any {
    return this._CustomValidationDTOKey;
  }
set CustomValidationDTOKey(value: any) {
    this._CustomValidationDTOKey = value;
    this._key = value;
  }
static setSummary = ($this, items) => {
                if (items == null) items = [];
                if ($this.Summary == null) $this.Summary = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Summary.length > 0) {
                    Domain.CustomValidationDTO.removeSummary($this, $this.Summary[0]);
                }

                Domain.CustomValidationDTO.addManySummary($this, copyItems);
            }
static addManySummary = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CustomValidationDTO.addSummary($this, items[i]);
                }
            }
static addSummary = ($this, item) => {
                if ($this.Summary == null) $this.Summary = [];
                if (item == null || $this.Summary.indexOf(item) > -1) return;
                $this.Summary.push(item);
}
static addRangeSummary = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CustomValidationDTO.addSummary($this, item));
            }
static removeSummary = ($this, item) => {
                if ($this == null || $this.Summary == null || $this.Summary.indexOf(item) === -1) return;
                var _index = $this.Summary.indexOf(item);
                $this.Summary.splice(_index, 1);
}
static clearSummary = ($this) => { $this.Summary = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CustomValidationDTOKey == null || $this.CustomValidationDTOKey == 0;
            }


}